import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApplicationStateService {
    private isMobileResolution: boolean;
    isTouchDevice = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
    isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    constructor() {
        if (window.innerWidth <= 1024 || this.isTouchDevice || this.isIPadPro) {
            this.isMobileResolution = true;
        } else {
            this.isMobileResolution = false;
        }
    }
    public getIsMobileResolution(): boolean {
        return this.isMobileResolution;
    }
}
